interface HirafiIconProps {
  className?: string;
  size?: number;
}

const HirafiIcon = ({ className, size = 36 }: HirafiIconProps) => (
  <img
    src="/favicon.svg"
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    draggable={false}
    className={className}
  />
);

export default HirafiIcon;
